import type {
    SelectionGroupsConstantType,
    SelectionGroupType
} from "./type";

export const getSelectionGroups = <E>({
    getHeading,
    entries,
    getKey
}: SelectionGroupsConstantType<E>): Array<SelectionGroupType<E>> => {
    const groups: Array<SelectionGroupType<E>> = [];

    const groupIndexes = new Map<string, number>();

    entries.forEach((entry) => {
        const groupKey = getKey(entry);

        const groupIndex = groupIndexes.get(groupKey);

        if(groupIndex !== undefined) {
            groups[groupIndex]?.options.push(entry);

            return;
        }

        groupIndexes.set(groupKey, groups.length);

        groups.push({
            heading: getHeading(entry),
            options: [
                entry
            ]
        });
    });

    return groups;
};
